import React, { useEffect, useMemo, useState } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import globalSettingsStores from '../../stores/settings-stores';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import globalConfigStore from '../../stores/global-config-store';
import { observer } from 'mobx-react-lite';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { AdvanceSearchUserDetails } from '../../pages/users/advance-search/operations/advance-search-operation';
import { FilterGetFilterComponenet } from './componenets/filter-get-filter-componenet';
import { EditText } from '../ui/edit-text/edit-text';
import { FilterExpanderWithListOfCheckboxes } from '../../components/CustomExpander/componenets/filter-expander-with-list-of-checkboxes';
import { CustomExpander } from '../../components/CustomExpander/CustomExpander';
import globalSettingsBranches from '../../stores/global-settings-branches';
import { getHebrewYear } from '../../utils/hebrew-date-utils';

interface SideBarSearchDataModel {
  updateSearchParameters: (
    userDetails?: AdvanceSearchUserDetails,
    majorsIds?: number[],
    abstractCousresIds?: number[],
    abstractProgramIds?: number[],
    supervisoryInstitutionIds?: number[],
    customFilterValues?: Record<string, any>,
    programStartYear?: number,
    branchIds?: number[],
  ) => any;
  maxHeight: string;
  setLoading: (loading: boolean) => any;
  addUserDetails: boolean;
  addMajors: boolean;
  addAbstractProgram: boolean;
  addAbstractCourses: boolean;
  addInstitution: boolean;
  addProgramStartYear: boolean;
  addBranches: boolean;
  customFilter?: { title: string; filterList: ColumnFilterCustomFilter[] };
}

export interface ColumnFilterCustomFilter {
  key: string;
  filterType: 'calendar_year' | 'text';
  title: string;
}

export const ColumnFilter: React.FC<SideBarSearchDataModel> = observer(
  ({
    updateSearchParameters,
    setLoading,
    maxHeight,
    addUserDetails,
    addAbstractCourses,
    addAbstractProgram,
    addMajors,
    addInstitution,
    addProgramStartYear,
    addBranches,
    customFilter,
  }) => {
    const [firstName, setFirstName] = useState<string | undefined>();
    const [lastName, setLastName] = useState<string | undefined>();
    const [nationalId, setNationalId] = useState<string | undefined>();
    const [phoneNumber, setPhoneNumber] = useState<string | undefined>();
    const [mail, setMail] = useState<string | undefined>();
    const [city, setCity] = useState<string | undefined>();

    const [selectedMajorIds, setSelectedMajorIds] = useState<number[]>([]);
    const [abstractCourseIds, setAbstractCourseIds] = useState<number[]>([]);
    const [abstractProgramIds, setAbstractProgramIds] = useState<number[]>([]);
    const [supervisoryInstitutionIds, setSupervisoryInstitutionIds] = useState<
      number[]
    >([]);
    const [programStartYear, setProgramStartYear] = useState<
      number | undefined
    >();
    const [selectedBranchIds, setSelectedBranchIds] = useState<number[]>([]);

    const toggleBranchId = (id: number) => {
      setSelectedBranchIds((prev) =>
        prev.includes(id) ? prev.filter((b) => b !== id) : [...prev, id],
      );
    };

    const toggleAbstractProgramId = (id: number) => {
      setAbstractProgramIds((prev) =>
        prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id],
      );
    };

    const toggleSupervisoryInstitutionId = (id: number) => {
      setSupervisoryInstitutionIds((prev) =>
        prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id],
      );
    };

    const toggleAbstractCourseId = (id: number) => {
      setAbstractCourseIds((prev) =>
        prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id],
      );
    };

    const toggleMajorId = (id: number) => {
      setSelectedMajorIds((prev) =>
        prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id],
      );
    };

    const [filteredCities, setFilteredCities] = useState<string[]>([]);
    const [loading2, setLoading2] = useState<boolean>(false);
    const [selectedCity, setSelectedCity] = useState<string | null>(null);

    const [cities, setCities] = useState<string[]>([]);

    // Handle selection
    const handleSelect = (e: { value: string }) => {
      setSelectedCity(e.value);
    };

    // Filter method for the autocomplete
    const searchCities = (event: { query: string }) => {
      // Filter the cities that start with the query
      const filtered = cities.filter((city) =>
        city.toLowerCase().startsWith(event.query.toLowerCase()),
      );
      setFilteredCities(filtered);
    };

    useEffect(() => {
      const getCitites = async () => {
        const citites = await globalConfigStore.getCities();
        setCities(citites);
      };

      getCitites();
    }, []);

    const handleSearch = async () => {
      await updateSearchParameters(
        {
          firstName: firstName,
          lastName: lastName,
          mail: mail,
          phoneNumber: phoneNumber,
          nationalId: nationalId,
        },
        selectedMajorIds,
        abstractCourseIds,
        abstractProgramIds,
        supervisoryInstitutionIds,
        customFilterValues,
        programStartYear,
        selectedBranchIds,
      );
    };

    const numberOfPersonalDetailsSelected = useMemo(() => {
      let count = 0;

      if (firstName?.trim()) count = count + 1;
      if (lastName?.trim()) count = count + 1;
      if (nationalId?.trim()) count = count + 1;
      if (phoneNumber?.trim()) count = count + 1;
      if (mail?.trim()) count = count + 1;
      if (selectedCity?.trim()) count = count + 1;

      return count;
    }, [firstName, lastName, nationalId, phoneNumber, mail, selectedCity]);

    const [customFilterValues, setCustomFilterValues] = useState<
      Record<string, any>
    >({});

    const [asd, setAsd] = useState(0);
    const handleCustomFilterChange = (key: string, value: any) => {
      setCustomFilterValues((prev) => ({
        ...prev,
        [key]: value,
      }));
    };

    useEffect(() => {
      const populatedFilterCount = Object.entries(customFilterValues).filter(
        ([key, value]) => {
          if (value === null || value === undefined) return false;
          if (typeof value === 'string' && value.trim() === '') return false;
          return true;
        },
      ).length;

      setAsd(populatedFilterCount);
    }, [customFilterValues]);

    // Generate years from 2000 to 2030
    const programYears = useMemo(() => {
      const years = [];
      for (let year = 2000; year <= 2030; year++) {
        years.push({
          year: `${getHebrewYear(year)} (${year} - ${year + 1})`,
          value: year,
        });
      }
      return years;
    }, []);

    // Modern styling matching the new design
    const styles = {
      container: {
        height: '100%',
        background: 'white',
        borderRadius: '8px',
        padding: '16px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column' as const,
      },
      header: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        marginBottom: '16px',
        color: '#333',
      },
      content: {
        flex: 1,
        overflowY: 'auto' as const,
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '8px',
        paddingRight: '4px',
        maxHeight: maxHeight,
      },
      buttonContainer: {
        marginTop: '16px',
        padding: '8px',
        borderTop: '1px solid #e9ecef',
      },
      searchButton: {
        width: '100%',
        backgroundColor: '#2196F3',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '12px',
        fontSize: '1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
      },
      personalDetailsSection: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '8px',
        padding: '8px 0',
      },
      radioGroup: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '8px',
        padding: '8px',
      },
      radioOption: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      },
    };

    return (
      <div style={styles.container}>
        <div style={styles.header}>סינונים</div>

        {addBranches && (
          <FilterExpanderWithListOfCheckboxes
            title="שלוחות"
            items={globalSettingsBranches.branches}
            selectedItems={selectedBranchIds}
            onItemToggle={toggleBranchId}
            getItemLabel={(branch) => branch.branchName}
            getItemKey={(branch) => branch.id}
            searchPlaceholder="חפש שלוחה..."
          />
        )}

        <div style={styles.content}>
          {addUserDetails && (
            <CustomExpander badge={numberOfPersonalDetailsSelected}>
              <div>פרטים אישיים</div>
              <div style={styles.personalDetailsSection}>
                <EditText
                  width={'220px'}
                  title={'שם'}
                  onChange={setFirstName}
                />

                <EditText
                  width={'220px'}
                  title={'שם משפחה'}
                  onChange={(text: string) => setLastName(text)}
                />

                <EditText
                  width={'220px'}
                  title={'ת.ז'}
                  onChange={(text: string) => setNationalId(text)}
                />

                <EditText
                  width={'220px'}
                  title={'מספר טלפון'}
                  onChange={(text: string) => setPhoneNumber(text)}
                />

                <EditText
                  width={'220px'}
                  title={'מייל'}
                  onChange={(text: string) => setMail(text)}
                />

                <div>
                  <label
                    style={{
                      fontSize: '14px',
                      color: '#4b5563',
                      display: 'block',
                      marginBottom: '4px',
                    }}
                  >
                    עיר
                  </label>
                  <AutoComplete
                    style={{
                      height: '36px',
                      minWidth: '220px',
                      direction: 'ltr',
                    }}
                    inputStyle={{ direction: 'rtl' }}
                    value={selectedCity}
                    suggestions={filteredCities}
                    completeMethod={searchCities}
                    field="name"
                    onChange={handleSelect}
                  />
                </div>
              </div>
            </CustomExpander>
          )}

          {addMajors && (
            <FilterExpanderWithListOfCheckboxes
              title="מגמות"
              items={globalSettingsStores.majors}
              selectedItems={selectedMajorIds}
              onItemToggle={toggleMajorId}
              getItemLabel={(major) => major.majorName}
              getItemKey={(major) => major.id}
              searchPlaceholder="חפש מגמה..."
            />
          )}

          {addAbstractCourses && (
            <FilterExpanderWithListOfCheckboxes
              title="קורסים טיפוסיים"
              items={globalSettingsStores.abstractCourses}
              selectedItems={abstractCourseIds}
              onItemToggle={toggleAbstractCourseId}
              getItemLabel={(course) => course.courseName}
              getItemKey={(course) => course.id}
              searchPlaceholder="חפש קורס..."
            />
          )}

          {addAbstractProgram && (
            <FilterExpanderWithListOfCheckboxes
              title="תכניות לימודים"
              items={globalSettingsStores.abstractProgram}
              selectedItems={abstractProgramIds}
              onItemToggle={toggleAbstractProgramId}
              getItemLabel={(program) => program.programName}
              getItemKey={(program) => program.id}
              searchPlaceholder="חפש תכנית..."
            />
          )}

          {addInstitution && (
            <FilterExpanderWithListOfCheckboxes
              title="גופים מפקחים"
              items={globalSettingsStores.supervisoryInstitution}
              selectedItems={supervisoryInstitutionIds}
              onItemToggle={toggleSupervisoryInstitutionId}
              getItemLabel={(institution) => institution.institutionName}
              getItemKey={(institution) => institution.id}
              searchPlaceholder="חפש גוף מפקח..."
            />
          )}

          {addProgramStartYear && (
            <CustomExpander>
              <div>שנת התחלה של תכנית</div>
              <div style={styles.radioGroup}>
                {programYears.map((yearOption) => (
                  <div key={yearOption.value} style={styles.radioOption}>
                    <RadioButton
                      inputId={yearOption.value.toString()}
                      name="programStartYear"
                      value={yearOption.value}
                      onChange={(e) => setProgramStartYear(e.value)}
                      checked={programStartYear === yearOption.value}
                    />
                    <label htmlFor={yearOption.value.toString()}>
                      {yearOption.year}
                    </label>
                  </div>
                ))}
              </div>
            </CustomExpander>
          )}

          {customFilter && customFilter.filterList.length > 0 && (
            <CustomExpander badge={asd}>
              <div>{customFilter.title}</div>
              <div style={styles.personalDetailsSection}>
                {customFilter.filterList.map((filter) => (
                  <FilterGetFilterComponenet
                    key={filter.key}
                    filterKey={filter.key}
                    filterType={filter.filterType}
                    title={filter.title}
                    value={customFilterValues[filter.key]}
                    onChange={handleCustomFilterChange}
                  />
                ))}
              </div>
            </CustomExpander>
          )}
        </div>

        <div style={styles.buttonContainer}>
          <Button
            label="חפש"
            icon="pi pi-search"
            style={styles.searchButton}
            onClick={handleSearch}
          />
        </div>
      </div>
    );
  },
);
